<template>
  <div class="publicNumTem">
    <div class="refresh"><i class="el-icon-refresh"></i>刷新</div>
    <div class="templatePanel">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="最新版设置" name='3.0.0'><VersionLast></VersionLast></el-tab-pane>
            <el-tab-pane label="新版设置" name='2.0.0'><VersionNew></VersionNew></el-tab-pane>
            <el-tab-pane label="旧版设置" name='1.0.0'><VersionOld></VersionOld></el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>

<script>
import VersionLast from './VersionLast'
import VersionNew from './VersionNew'
import VersionOld from './VersionOld'
export default {
  data(){
      return{
          activeName:'3.0.0'
      }
  },
  components:{
    //   VersionLast:()=>import('./VersionLast'),
    //   VersionNew:()=>import('./VersionNew'),
    //   VersionOld:()=>import('./VersionOld'),
    VersionLast,
    VersionNew,
    VersionOld
  },
  methods:{
      handleClick(tab,event){

      }
  }
}
</script>

<style scoped>
.publicNumTem{
    height: calc(100vh - 60px);
    background-color: #ffffff;
    padding: 0px 20px;
}
.publicNumTem .refresh{
    color:#666666;
    text-align: right;
    line-height: 30px;
}
.publicNumTem .templatePanel{
    border:1px solid rgb(230, 230, 230);;
    padding:0px 10px 10px 10px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.1);
    margin:10px 0px 10px 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/system/wechat/Template.vue